import {AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ProblemDetails} from '../data/problemDetails';
import {LoggerService} from '../../logging/services/logger.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSource} from '../../logging/data/logSource';
import {LogSourceType} from '../../logging/data/logSourceType';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[problem-details]'
})
export class ProblemDetailsDirective<T> implements OnChanges, AfterViewInit {
  @Input('problem-details')problemDetailsModel: ProblemDetails<T>;
  @Input() problemDetailsKey: string = '';

  errorLabel: HTMLElement;

  constructor(private element: ElementRef,
              private loggerService: LoggerService) {

  }

  ngAfterViewInit() {
    this.createErrorLabel(this.element);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.errorLabel) {
      return;
    }
    if (this.checkIfProblem()) {
      this.element.nativeElement.classList.add('has-error');
      const errors = this.getProblems();
      this.showErrorLabel(errors);
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.ProblemDetailsDirective, `Showing error label for ${this.problemDetailsKey}`);
    } else {
      this.element.nativeElement.classList.remove('has-error');
      this.hideErrorLabel();
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.ProblemDetailsDirective, `Hiding error label for ${this.problemDetailsKey}`);
    }
  }

  checkIfProblem(): boolean {
    if (!this.problemDetailsModel) {
      return false;
    }
    const keySplits = this.problemDetailsKey.split('.');
    let currentModel = this.problemDetailsModel.MODEL;
    for (const keySplit of keySplits) {
      if (!currentModel[keySplit.toLowerCase()]) {
        return false;
      }
      currentModel = currentModel[keySplit.toLowerCase()];
    }
    return true;
  }

  getProblems(): string[] {
    if (!this.problemDetailsModel) {
      return [];
    }
    const keySplits = this.problemDetailsKey.split('.');
    let currentModel = this.problemDetailsModel.MODEL as any;
    for (const keySplit of keySplits) {
      currentModel = currentModel[keySplit.toLowerCase()];
    }
    return currentModel as string[];
  }

  private createErrorLabel(element: ElementRef) {
    const errorLabel = document.createElement('div');
    errorLabel.innerText = 'I';
    errorLabel.classList.add('error-label');
    errorLabel.classList.add('error-label-hidden');
    const parent = element.nativeElement.parentElement;
    const sibling = element.nativeElement.nextSibling;
    if (sibling) {
      parent.insertBefore(errorLabel, sibling);
    } else {
      parent.appendChild(errorLabel);
    }
    this.errorLabel = errorLabel;
  }

  private showErrorLabel(errors: string[]) {
    this.errorLabel.innerHTML = errors.join('<br>');
    this.errorLabel.classList.remove('error-label-hidden');
  }

  private hideErrorLabel() {
    this.errorLabel.classList.add('error-label-hidden');
  }
}
